//<script type="text/javascript">
    if (typeof shippingInsuranceClaimsInitialized == 'undefined') {
        shippingInsuranceClaimsInitialized = true;
    
        console.log("Claims Loaded modified");
        
        var orderIds = [];
    
        var claimsContainerSelector = '.order-history';
        //Luxy Account Order History Selector
        if (!document.querySelector(claimsContainerSelector)) {
            if (document.querySelector('.table-account-order')) {
                claimsContainerSelector = '.table-account-order';
                console.log('Selector present');
            }
        }
        var claimsChildSelector = ' tbody tr > :first-child';
        var claimsContainerType = 'table';
    
        //Luxy Order page Selector
        if (document.querySelector('.customer-order-container')) {
            claimsContainerType = 'order_page';
            claimsContainerSelector = '.customer-order-container';
            claimsChildSelector = ' > h1';
        }
    
        //Extracting Order IDs
        if (claimsContainerType == 'table') {
            var orders = document.querySelectorAll(claimsContainerSelector + claimsChildSelector);
            if (orders && orders.length) {
                orders.forEach(function(e) {
                    var orderId = e.innerText;
                    if (orderId) {
                        orderIds.push(orderId);
                    }
                });
            }
        } else if (claimsContainerType == 'order_page') {
            var order = document.querySelector(claimsContainerSelector + claimsChildSelector).innerText.replace('Order ', '').replace('ORDER ', '');
            order = order.split(" ")[0];
            orderIds.push(order);
        }
        
        if (orderIds.length) {
            var claimsContainer = document.querySelector(claimsContainerSelector);
    
            if (claimsContainerType == 'table') {
                var claimHeader = document.createElement('th');
                claimHeader.id = 'ColumnClaimsButton';
                claimHeader.innerHTML = 'Claim';
                claimsContainer.querySelector('thead tr:first-child').appendChild(claimHeader);
                document.querySelectorAll(claimsContainerSelector + claimsChildSelector).forEach(function(e) {
                    console.log(e)
                    var claimTd = document.createElement('td');
                    claimTd.classList.add('ColumnClaim');
                    var claimLoader = document.createElement('div');
                    claimLoader.classList.add('claimButtonLoader');
                    claimTd.appendChild(claimLoader);
                    e.parentElement.appendChild(claimTd);
                });
            } else if (claimsContainerType == 'order_page') {
                var claimLoader = document.createElement('div');
                claimLoader.classList.add('claimButtonLoader');
                document.querySelector(claimsContainerSelector).append(claimLoader);
            }
            var stylesString = '.iframe-lightbox,.iframe-lightbox .backdrop{display:block;width:100%;height:100%;top:0;left:0}.iframe-lightbox{display:none;position:fixed;opacity:0;-webkit-transition:opacity .2s ease;transition:opacity .2s ease;z-index:999999}.iframe-lightbox .backdrop{position:absolute;background-color:rgba(0,0,0,.92);cursor:default}.iframe-lightbox .content-holder{width:80%;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);margin-right:-50%}.iframe-lightbox .content{height:0;position:relative;padding-bottom:56.25%}.iframe-lightbox .content>.body{position:absolute;top:0;left:0;width:100%;height:100%}.iframe-lightbox .content>.body .half-circle-spinner,.iframe-lightbox .content>.body .half-circle-spinner *{-webkit-box-sizing:border-box;box-sizing:border-box}.iframe-lightbox .content>.body .half-circle-spinner{display:block;width:60px;height:60px;border-radius:100%;position:relative;margin:0;position:fixed;top:50%;left:50%;margin-right:-50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.iframe-lightbox .content>.body .half-circle-spinner .circle{content:"";display:block;position:absolute;width:100%;height:100%;border-radius:100%;border:calc(60px / 10) solid transparent}.iframe-lightbox .content>.body .half-circle-spinner .circle.circle-1{display:block;border-top-color:#fff;-webkit-animation:half-circle-spinner-animation 1s infinite;animation:half-circle-spinner-animation 1s infinite}.iframe-lightbox .content>.body .half-circle-spinner .circle.circle-2{display:block;border-bottom-color:#fff;-webkit-animation:half-circle-spinner-animation 1s infinite alternate;animation:half-circle-spinner-animation 1s infinite alternate}@-webkit-keyframes half-circle-spinner-animation{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes  half-circle-spinner-animation{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.iframe-lightbox .content>.body.is-loaded .half-circle-spinner{display:none}.iframe-lightbox iframe{display:block;width:100%;height:100%;max-width:600px;margin:auto;border:0;-webkit-box-shadow:.267rem .267rem .267rem 0 rgba(3,3,3,.3);box-shadow:.267rem .267rem .267rem 0 rgba(3,3,3,.3);opacity:0;-webkit-transition:opacity .2s ease;transition:opacity .2s ease}.iframe-lightbox.is-showing{display:block}.iframe-lightbox.is-opened{opacity:1}.iframe-lightbox .btn-close{display:block;position:fixed;top:1rem;right:1rem;width:1.5rem;height:1.5rem;font-size:1rem;outline:0;cursor:pointer;border:0;background-color:transparent}.iframe-lightbox .btn-close:after,.iframe-lightbox .btn-close:before{content:" ";width:.125em;height:1.5em;position:absolute;top:0;right:25px;background:#000;}.iframe-lightbox .btn-close:before{-webkit-transform:rotate(45deg);transform:rotate(45deg)}.iframe-lightbox .btn-close:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.iframe-lightbox--open{overflow:hidden;-webkit-overflow-scrolling:touch;-ms-touch-action:auto;touch-action:auto;height:auto} body .iframe-lightbox .btn-close{position: absolute;width: 50px;z-index: 11;left: calc(50% + 250px);background: none;margin: 0;} .claim-heading{margin: 0 34px 2rem;}';
            stylesString += 'body .claimButtonLoader,.claimButtonLoader:after{display:inline-block;border-radius:50%;width:3em;height:3em}.claimButtonLoader{margin:0px auto;font-size:10px;position:relative;text-indent:-9999em;border-top:.5em solid rgba(0,0,0,.2);border-right:.5em solid rgba(0,0,0,.2);border-bottom:.5em solid rgba(0,0,0,.2);border-left:.5em solid #fff;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);-webkit-animation:load8 1.1s infinite linear;animation:load8 1.1s infinite linear}@-webkit-keyframes load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes  load8{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}} .order-claim-button{display:block; padding: 10px 20px;float:right;color:#FFF;background:#ea0d81;clear:both;margin-bottom:20px;} a.order-claim-button:hover{color:#e9e9e9;}';
            stylesString += '@media (max-width:767px){body .iframe-lightbox .content-holder{width: 100%;margin: 0;transform: none;top: 0;left: 0;height: 100%;} body .iframe-lightbox .content-holder .content{height: 85%;padding: 0;}} .iframe-lightbox iframe,.iframe-lightbox .content-holder{max-height: 100vh;} @media (max-width:600px){.iframe-lightbox .btn-close {right: 0 !important;left: unset !important;} .claim-heading{margin-left: 50px; margin-right:50px;}}';
            var linkElement = this.document.createElement('link');
            linkElement.setAttribute('rel', 'stylesheet');
            linkElement.setAttribute('type', 'text/css');
            linkElement.setAttribute('href', 'data:text/css;charset=UTF-8,' + encodeURIComponent(stylesString));
            document.querySelector('head').appendChild(linkElement);
    
            window.globalWorkaroundLightboxClose = false;
            window.globalWorkaroundLightboxCloseButton = false;
    
            //lightbox include
            !function(s, o) {
                "use strict";
                function t(t, e) {
                    var i = e || {};
                    this.trigger = t,
                    this.el = o.getElementsByClassName(l)[0] || "",
                    this.body = this.el ? this.el.getElementsByClassName("body")[0] : "",
                    this.content = this.el ? this.el.getElementsByClassName("content")[0] : "",
                    this.src = t.dataset.src || "",
                    this.href = t.getAttribute("href") || "",
                    this.dataPaddingBottom = t.dataset.paddingBottom || "",
                    this.dataScrolling = t.dataset.scrolling || "",
                    this.dataTouch = t.dataset.touch || "",
                    this.rate = i.rate || 500,
                    this.scrolling = i.scrolling,
                    this.touch = i.touch,
                    this.onOpened = i.onOpened,
                    this.onIframeLoaded = i.onIframeLoaded,
                    this.onLoaded = i.onLoaded,
                    this.onCreated = i.onCreated,
                    this.onClosed = i.onClosed,
                    this.init()
                }
                var n = o.documentElement || ""
                  , a = o.body || ""
                  , l = "iframe-lightbox"
                  , d = "iframe-lightbox-window--is-binded"
                  , e = "iframe-lightbox--open"
                  , r = "iframe-lightbox-link--is-binded"
                  , c = "is-loaded"
                  , i = "is-opened"
                  , h = "is-showing"
                  , u = null !== navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i) || void 0 !== o.createTouch || "ontouchstart"in s || "onmsgesturechange"in s || navigator.msMaxTouchPoints;
                t.prototype.init = function() {
                    var t = this;
                    this.el || this.create();
                    function e() {
                        t.open()
                    }
                    function i(t) {
                        t.stopPropagation(),
                        t.preventDefault(),
                        function(i, s) {
                            var n, o, a, l;
                            return function() {
                                a = this,
                                o = [].slice.call(arguments, 0),
                                l = new Date,
                                n || (n = setTimeout(function t() {
                                    var e = new Date - l;
                                    e < s ? n = setTimeout(t, s - e) : (n = null,
                                    i.apply(a, o))
                                }, s))
                            }
                        }(e, this.rate).call()
                    }
                    this.trigger.classList.contains(r) || (this.trigger.classList.add(r),
                    this.trigger.addEventListener("click", i),
                    u && (t.touch || t.dataTouch) && this.trigger.addEventListener("touchstart", i))
                }
                ,
                t.prototype.create = function() {
                    var e = this
                      , t = o.createElement("div");
                    t.classList.add("backdrop"),
                    this.el = o.createElement("div"),
                    this.el.classList.add(l),
                    this.el.appendChild(t),
                    this.content = o.createElement("div"),
                    this.content.classList.add("content"),
                    this.body = o.createElement("div"),
                    this.body.classList.add("body"),
                    this.content.appendChild(this.body),
                    this.contentHolder = o.createElement("div"),
                    this.contentHolder.classList.add("content-holder"),
                    this.contentHolder.appendChild(this.content),
                    this.el.appendChild(this.contentHolder),
                    this.btnClose = o.createElement("button"),
                    this.btnClose.classList.add("btn-close"),
                    this.contentHolder.appendChild(this.btnClose),
                    a.appendChild(this.el),
                    t.addEventListener("click", function() {
                        e.close()
                    }),
                    this.btnClose.addEventListener("click", function() {
                        e.close()
                    }),
                    n.classList.contains(d) || (n.classList.add(d),
                    s.addEventListener("keyup", function(t) {
                        27 === (t.which || t.keyCode) && e.close()
                    }));
                    function i() {
                        e.isOpen() || (e.el.classList.remove(h),
                        e.body.innerHTML = "")
                    }
                    this.el.addEventListener("transitionend", i, !1),
                    this.el.addEventListener("webkitTransitionEnd", i, !1),
                    this.el.addEventListener("mozTransitionEnd", i, !1),
                    this.el.addEventListener("msTransitionEnd", i, !1),
                    this.callCallback(this.onCreated, this)
                }
                ,
                t.prototype.loadIframe = function() {
                    var t = this;
                    this.iframeId = l + Date.now(),
                    this.iframeSrc = this.src || this.href || "";
                    var e, i, s, n = [];
                    n.push('<iframe src="' + this.iframeSrc + '" name="' + this.iframeId + '" id="' + this.iframeId + '" onload="this.style.opacity=1;" style="opacity:0;border:none;" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" height="166" frameborder="no"></iframe>'),
                    n.push('<div class="half-circle-spinner"><div class="circle circle-1"></div><div class="circle circle-2"></div></div>'),
                    this.body.innerHTML = n.join(""),
                    e = this.iframeId,
                    i = this.body,
                    (s = o.getElementById(e)).onload = function() {
                        this.style.opacity = 1,
                        i.classList.add(c),
                        t.scrolling || t.dataScrolling ? (s.removeAttribute("scrolling"),
                        s.style.overflow = "scroll") : (s.setAttribute("scrolling", "no"),
                        s.style.overflow = "hidden"),
                        t.callCallback(t.onIframeLoaded, t),
                        t.callCallback(t.onLoaded, t)
                    }
                }
                ,
                t.prototype.open = function() {
                    this.loadIframe(),
                    this.dataPaddingBottom ? this.content.style.paddingBottom = this.dataPaddingBottom : this.content.removeAttribute("style"),
                    this.el.classList.add(h),
                    this.el.classList.add(i),
                    n.classList.add(e),
                    a.classList.add(e),
                    this.callCallback(this.onOpened, this)
                }
                ,
                t.prototype.close = function() {
                    this.el.classList.remove(i),
                    this.body.classList.remove(c),
                    n.classList.remove(e),
                    a.classList.remove(e),
                    this.callCallback(this.onClosed, this)
                }
                ,
                t.prototype.isOpen = function() {
                    return this.el.classList.contains(i)
                }
                ,
                t.prototype.callCallback = function(t, e) {
                    "function" == typeof t && t.bind(this)(e)
                }
                ,
                s.IframeLightbox = t
            }("undefined" != typeof window ? window : this, document);
    
            // var accessToken = JSON.parse(document.querySelector('#shopify-features').innerHTML).accessToken;
            var customerId = meta.page.customerId;
    
            var claimDataUrl = "https://packageprotection-app.beautyindustrygroup.com/frontend/claim/check?customerId=" + encodeURIComponent(customerId) + "&shop=" + encodeURIComponent("luxyhair.myshopify.com");
            orderIds.forEach(function(orderId) {
                claimDataUrl += "&orderId[]=" + encodeURIComponent(orderId);
            });
            fetch(claimDataUrl).then(response=>response.json()).then(data=>{
                data.forEach(function(orderJson) {
                    console.log(orderJson)
                    if (claimsContainerType == 'table') {
                        var rows = document.querySelectorAll(claimsContainerSelector + claimsChildSelector);
                        if (rows && rows.length) {
                            rows.forEach(function(row) {
                                if (row.innerText == orderJson.orderId) {
                                    var claimColumn = row.parentElement.querySelector('.ColumnClaim');
                                    claimColumn.innerHTML = '';
                                    if (orderJson.filed) {
                                        var claimButton = document.createElement('a');
                                        claimButton.href = orderJson.claimLink;
                                        claimButton.classList.add('iframe-lightbox-link');
                                        claimButton.innerText = 'View Claim';
                                        claimColumn.appendChild(claimButton);
                                        claimButton.lightbox = new IframeLightbox(claimButton,{
                                            onLoaded: function() {
                                                window.globalWorkaroundLightboxClose = false;
                                                window.globalWorkaroundLightboxCloseButton = false;
                                            },
                                            scrolling: true,
                                            onClosed: function() {
                                                if (window.globalWorkaroundLightboxClose === false) {
                                                    return true;
                                                }
                                                var orderId = window.globalWorkaroundLightboxClose;
                                                var claimColumn = globalWorkaroundLightboxCloseButton.parentElement;
                                                window.globalWorkaroundLightboxCloseButton.style.display = 'none';
                                                if (document.querySelector('.claimButtonLoader') === null) {
                                                    var claimLoader = document.createElement('div');
                                                    claimLoader.classList.add('claimButtonLoader');
                                                    claimColumn.appendChild(claimLoader);
                                                }
                                                var claimDataRefreshUrl = "https://packageprotection-app.beautyindustrygroup.com/frontend/claim/check?customerId=" + encodeURIComponent(customerId) + "&shop=" + encodeURIComponent("luxyhair.myshopify.com") + "&orderId[]=" + encodeURIComponent(orderId);
                                                fetch(claimDataRefreshUrl).then(response=>response.json()).then(data=>{
                                                    if (data.length) {
                                                        if (data[0].filed) {
                                                            window.globalWorkaroundLightboxCloseButton.innerHTML = 'View Claim';
                                                            window.globalWorkaroundLightboxCloseButton.href = data[0].claimLink;
                                                            window.globalWorkaroundLightboxCloseButton.style.display = 'inline';
                                                            document.querySelector('.claimButtonLoader').remove();
                                                        } else {
                                                            window.globalWorkaroundLightboxCloseButton.style.display = 'inline';
                                                            document.querySelector('.claimButtonLoader').remove();
                                                        }
                                                    } else {
                                                        window.globalWorkaroundLightboxCloseButton.style.display = 'inline';
                                                        document.querySelector('.claimButtonLoader').remove();
                                                    }
                                                }
                                                );
                                            }
                                        });
                                    } else if (orderJson.fileable) {
                                        var claimButton = document.createElement('a');
                                        claimColumn.classList.add('claim_column_order_' + orderJson.orderId.replace('#', ''));
                                        claimButton.href = orderJson.claimLink;
                                        claimButton.classList.add('iframe-lightbox-link');
                                        claimButton.innerText = 'File Shipping Protection Claim';
                                        claimColumn.appendChild(claimButton);
                                        claimButton.lightbox = new IframeLightbox(claimButton,{
                                            onLoaded: function() {
                                                window.globalWorkaroundLightboxClose = orderJson.orderId;
                                                window.globalWorkaroundLightboxCloseButton = claimButton;
                                            },
                                            onClosed: function() {
                                                if (window.globalWorkaroundLightboxClose === false) {
                                                    return true;
                                                }
                                                var orderId = window.globalWorkaroundLightboxClose;
                                                var claimColumn = globalWorkaroundLightboxCloseButton.parentElement;
                                                window.globalWorkaroundLightboxCloseButton.style.display = 'none';
                                                if (document.querySelector('.claimButtonLoader') === null) {
                                                    var claimLoader = document.createElement('div');
                                                    claimLoader.classList.add('claimButtonLoader');
                                                    claimColumn.appendChild(claimLoader);
                                                }
                                                var claimDataRefreshUrl = "https://packageprotection-app.beautyindustrygroup.com/frontend/claim/check?customerId=" + encodeURIComponent(customerId) + "&shop=" + encodeURIComponent("luxyhair.myshopify.com") + "&orderId[]=" + encodeURIComponent(orderId);
                                                fetch(claimDataRefreshUrl).then(response=>response.json()).then(data=>{
                                                    if (data.length) {
                                                        if (data[0].filed) {
                                                            window.globalWorkaroundLightboxCloseButton.innerHTML = 'View Claim';
                                                            window.globalWorkaroundLightboxCloseButton.href = data[0].claimLink;
                                                            window.globalWorkaroundLightboxCloseButton.style.display = 'inline';
                                                            document.querySelector('.claimButtonLoader').remove();
                                                        } else {
                                                            window.globalWorkaroundLightboxCloseButton.style.display = 'inline';
                                                            document.querySelector('.claimButtonLoader').remove();
                                                        }
                                                    } else {
                                                        window.globalWorkaroundLightboxCloseButton.style.display = 'inline';
                                                        document.querySelector('.claimButtonLoader').remove();
                                                    }
                                                }
                                                );
                                            },
                                            scrolling: true
                                        });
                                    } else {
                                        claimColumn.innerHTML = '<span>N/A</span>';
                                    }
                                }
                            });
                            window.addEventListener('message', function(e) {
                                if (e.origin !== 'https://packageprotection-app.beautyindustrygroup.com')
                                    return;
                                if (e.data.closeModal) {
                                    document.querySelector('.btn-close').click();
                                }
                            }, false);
                        }
                    } else if (claimsContainerType == 'order_page') {
                        document.querySelector('.claimButtonLoader').remove();
                        var claimContainer = document.createElement('div');
                        claimContainer.classList.add('order_claim');
                        document.querySelector(claimsContainerSelector).append(claimContainer);
                        if (orderJson.filed) {
                            var claimButton = document.createElement('a');
                            claimButton.href = orderJson.claimLink;
                            claimButton.classList.add('iframe-lightbox-link');
                            claimButton.classList.add('order-claim-button');
                            claimButton.innerText = 'View Claim';
                            claimContainer.appendChild(claimButton);
                            claimButton.lightbox = new IframeLightbox(claimButton,{
                                scrolling: true
                            });
                        } else if (orderJson.fileable) {
                            var claimButton = document.createElement('a');
                            claimButton.href = orderJson.claimLink;
                            claimButton.classList.add('iframe-lightbox-link');
                            claimButton.classList.add('order-claim-button');
                            claimButton.innerText = 'File Shipping Protection Claim';
                            claimContainer.appendChild(claimButton);
                            claimButton.lightbox = new IframeLightbox(claimButton,{
                                onClosed: function() {
                                    var orderId = orderIds[0];
                                    var claimContainer = claimButton.parentElement;
                                    claimButton.style.display = 'none';
                                    if (document.querySelector('.claimButtonLoader') === null) {
                                        var claimLoader = document.createElement('div');
                                        claimLoader.classList.add('claimButtonLoader');
                                        claimContainer.appendChild(claimLoader);
                                    }
                                    var claimDataRefreshUrl = "https://packageprotection-app.beautyindustrygroup.com/frontend/claim/check?customerId=" + encodeURIComponent(customerId) + "&shop=" + encodeURIComponent("luxyhair.myshopify.com") + "&orderId[]=" + encodeURIComponent(orderId);
                                    fetch(claimDataRefreshUrl).then(response=>response.json()).then(data=>{
                                        if (data.length) {
                                            if (data[0].filed) {
                                                document.querySelector('.order-claim-button').innerHTML = 'View Claim';
                                                document.querySelector('.order-claim-button').href = data[0].claimLink;
                                                document.querySelector('.order-claim-button').style.display = 'block';
                                                document.querySelector('.claimButtonLoader').remove();
                                            } else {
                                                document.querySelector('.order-claim-button').style.display = 'block';
                                                document.querySelector('.claimButtonLoader').remove();
                                            }
                                        } else {
                                            document.querySelector('.order-claim-button').style.display = 'block';
                                            document.querySelector('.claimButtonLoader').remove();
                                        }
                                    }
                                    );
                                },
                                scrolling: true
                            });
                        }
                        window.addEventListener('message', function(e) {
                            if (e.origin !== 'https://packageprotection-app.beautyindustrygroup.com')
                                return;
                            if (e.data.closeModal) {
                                document.querySelector('.btn-close').click();
                            }
                        }, false);
                    }
                })
            }
            );
        }
    }